import { InputType } from 'config'

export const counterPartyWorkflowOptions = {
  0: 'Standard Workflow – Requires Invitation',
  1: 'Direct Workflow – Immediate Document Upload',
}

export const defaultCounterPartyConfigInputs = (): Record<string, InputType> => {
  return {
    workflow: {
      title: 'Counter Party Workflow',
      inputType: 'select',
      options: counterPartyWorkflowOptions,
    },
  }
}
